import React from 'react'
import { TableStateType } from './TableTypes'

const ErrorStateOverlay = ({ errorState }: { errorState: TableStateType }) => {
  return (
    <div className="h-80 flex justify-center flex-col items-center gap-2 ">
      {errorState?.icon}
      {errorState?.title && (
        <span className="text-dark font-semibold  mt-4">
          {errorState.title}
        </span>
      )}
      {errorState?.subtitle && (
        <span className="text-dark-4 text-base">{errorState.subtitle}</span>
      )}

      {errorState?.content && <div>{errorState.content}</div>}
    </div>
  )
}

export default ErrorStateOverlay
